<template>
  <div class="div-container" :class="{ 'div-container-inner': tabChoosed == '内饰' }"
      :style="{ backgroundImage: `URL(${bgImg})`,backgroundColor: 'rgba(242, 242, 242, 1)' }">
       

    <div class="title">Vehicle</div>
    <div class="top">
      <div class="car">
        <div class="car-name">
          <span @click="isShowCarListChange" class="car-name-pre" style="margin-right: 0;padding-right: 0.52vw;">全新赛图斯</span>
          <span @click="isShowCarListChange">{{ carChoosed.name }}</span>
          <i @click="isShowCarListChange" class="el-icon-arrow-down jiantou" :class="{ 'open': isShowCarList }"></i>
          <div class="car-list" :class="{ 'open': isShowCarList }">
            <div class="car-list-item" v-for="item in carsList" :key="item.name" @click="chooseCar(item)" :code-stm="`event, PAGEURL页面, 车型卡片_新狮铂拓界${item.name}`"><span
              class="pre">全新赛图斯</span>{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div class="tab">
        <div class="tab-item" :class="{ 'tab-item-active': item == tabChoosed }" v-for="item in tabsList" :key="item" :code-stm="`event, PAGEURL页面, 新狮铂拓界外观/内饰切换类型_${item}`"
             @click="chooseTab(item)">{{ item }}</div>
      </div>
    </div>
    <img :src="origin+carImg" alt="" class="car-img" v-if="tabChoosed == '外观'">
    <div class="bottom">
      <div class="color" v-if="tabChoosed == '外观' || !isPortrait">
        <div class="color-name">{{ colorChoosed.name }}</div>
        <div class="color-box" :class="colorsList.length > 6 ? 'wrap-box':''">
          <div :code-stm="`event, PAGEURL页面, 新狮铂拓界外观颜色_${item.name}`"
            class="color-box-item" :class="colorsList.length > 6 ? 'wrap-item':''" v-for="item in colorsList" :key="item.name" @click="chooseColor(item, 'click')"
            :style="{ backgroundImage: `URL(${origin+item.icon})` }">
            <i class="el-icon-check" v-if="item.name == colorChoosed.name"
               :style="{ color: item.name != '珍珠白' ? '#fff' : '#000' }"></i>
          </div>
        </div>
      </div>
      <div class="inner" v-if="tabChoosed == '内饰' || !isPortrait">
        <div class="inner-name">内饰颜色：{{ innerChoosed.name }}</div>
        <div class="inner-box">
          <div class="inner-box-item" v-for="item in innerList" :key="item.name" @click="chooseInner(item,'click')" :code-stm="`event, PAGEURL页面, 新狮铂拓界内饰颜色_${item.name}`"
               :style="{ backgroundImage: `URL(${origin+item.icon})` }">
            <i class="el-icon-check" v-if="item.name == innerChoosed.name"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="tip">*车型图片等信息仅供参考，具体以实车为准</div>
  </div>
</template>

<script>
import { isPortraitFun, getUrlKey, isPc } from "@/utils/utils.js";
export default {
  data() {
    return {
      isPortrait: isPortraitFun(),
      isPC: isPc(),
      isShowCarList: false,
      carsList: [
        {
          name: "",
          colorsList: [
          {
              name: "水青绿",
              img: "/assets/~/media/images/vehicle/newseltos/color/pc/outer/shuiqinglvche.png",
              icon: "/assets/~/media/images/vehicle/newseltos/color/pc/outer/shuiqinglv.png"
            },
            {
              name: "云逸蓝",
              img: "/assets/~/media/images/vehicle/newseltos/color/pc/outer/yunyilanche.png",
              icon: "/assets/~/media/images/vehicle/newseltos/color/pc/outer/yunyilan.png"
            },
            {
              name: "珍珠白",
              img: "/assets/~/media/images/vehicle/newseltos/color/pc/outer/zhenzhubaiche.png",
              icon: "/assets/~/media/images/vehicle/newseltos/color/pc/outer/zhenzhubai.png"
            },
            {
              name: "耀辉银",
              img: "/assets/~/media/images/vehicle/newseltos/color/pc/outer/yaohuiyinche.png",
              icon: "/assets/~/media/images/vehicle/newseltos/color/pc/outer/yaohuiyin.png"
            },
            {
              name: "极光黑",
              img: "/assets/~/media/images/vehicle/newseltos/color/pc/outer/jiguangheiche.png",
              icon: "/assets/~/media/images/vehicle/newseltos/color/pc/outer/jiguanghei.png"
            },
            
            {
              name: "云逸蓝+极光黑",
              img: "/assets/~/media/images/vehicle/newseltos/color/pc/outer/yunyilanshuangseche.png",
              icon: "/assets/~/media/images/vehicle/newseltos/color/pc/outer/yunyilanshuangse.png"
            },
            
            {
              name: "珍珠白+极光黑",
              img: "/assets/~/media/images/vehicle/newseltos/color/pc/outer/zhenzhubaishuangseche.png",
              icon: "/assets/~/media/images/vehicle/newseltos/color/pc/outer/zhenzhubaishuangse.png"
            },
            
          ],
          innerList: [
            {
              name: "黑灰内饰",
              img: "/assets/~/media/images/vehicle/newseltos/color/pc/inner/heihuitu.jpg",
              icon: "/assets/~/media/images/vehicle/newseltos/color/pc/inner/heihui.png"
            },
            {
              name: "棕灰内饰",
              img: "/assets/~/media/images/vehicle/newseltos/color/pc/inner/zonghuitu.jpg",
              icon: "/assets/~/media/images/vehicle/newseltos/color/pc/inner/zonghui.png"
            },
            {
              name: "绿灰内饰",
              img: "/assets/~/media/images/vehicle/newseltos/color/pc/inner/lvhuitu.jpg",
              icon: "/assets/~/media/images/vehicle/newseltos/color/pc/inner/lvhui.png"
            }
          ]
        },
        {
          name: "X-Line",
          colorsList: [
            {
              name: "水青绿",
              img: "/assets/~/media/images/vehicle/newseltos/color/pc/outer/xlineshuiqinglvche.png",
              icon: "/assets/~/media/images/vehicle/newseltos/color/pc/outer/shuiqinglv.png"
            },
            {
              name: "云逸蓝",
              img: "/assets/~/media/images/vehicle/newseltos/color/pc/outer/xlineyunyilanche.png",
              icon: "/assets/~/media/images/vehicle/newseltos/color/pc/outer/yunyilan.png"
            },
            {
              name: "珍珠白",
              img: "/assets/~/media/images/vehicle/newseltos/color/pc/outer/xlinezhenzhubaiche.png",
              icon: "/assets/~/media/images/vehicle/newseltos/color/pc/outer/zhenzhubai.png"
            },
            {
              name: "极光黑",
              img: "/assets/~/media/images/vehicle/newseltos/color/pc/outer/xlinejiguangheiche.png",
              icon: "/assets/~/media/images/vehicle/newseltos/color/pc/outer/jiguanghei.png"
            },
            
            {
              name: "云逸蓝+极光黑",
              img: "/assets/~/media/images/vehicle/newseltos/color/pc/outer/xlineyunyilanshuangseche.png",
              icon: "/assets/~/media/images/vehicle/newseltos/color/pc/outer/yunyilanshuangse.png"
            },
            
            {
              name: "珍珠白+极光黑",
              img: "/assets/~/media/images/vehicle/newseltos/color/pc/outer/xlinezhenzhubaishuangseche.png",
              icon: "/assets/~/media/images/vehicle/newseltos/color/pc/outer/zhenzhubaishuangse.png"
            },
            
            {
              name: "哑光灰",
              img: "/assets/~/media/images/vehicle/newseltos/color/pc/outer/xlineyaguanghuiche.png",
              icon: "/assets/~/media/images/vehicle/newseltos/color/pc/outer/xlineyaguanghui.png"
            },
            {
              name: "花火橙",
              img: "/assets/~/media/images/vehicle/newseltos/color/pc/outer/xlinehuahuochengche.png",
              icon: "/assets/~/media/images/vehicle/newseltos/color/pc/outer/xlinehuahuocheng.png"
            }
          ],
          innerList: [
            {
              name: "黑色内饰",
              img: "/assets/~/media/images/vehicle/newseltos/color/pc/inner/xlineheisetu.jpg",
              icon: "/assets/~/media/images/vehicle/newseltos/color/pc/inner/xlineheise.png"
            }
          ]
        }
      ],
      carChoosed: {},
      // carBgImg: require('../assets/images/ev6/out-inner-bg.png'),
      // bgImg: require('../assets/images/ev6/out-inner-bg.png'),
      carBgImg: '',
      bgImg: '',
      tabsList: ["外观", "内饰"],
      tabChoosed: "外观",
      colorsList: [],
      colorChoosed: "",
      carImg: "",
      innerList: [],
      innerChoosed: {},
      innerImg: "",
      origin: "",
    };
  },
  watch: {
    carChoosed(n) {
      console.log(n);
      this.colorsList = this.carChoosed.colorsList
      this.innerList = this.carChoosed.innerList
      this.innerChoosed = this.innerList[0]
      if (this.tabChoosed == "外观") {
        this.chooseColor(this.colorsList[0])
      } else {
        this.chooseInner(this.innerList[0])
      }
    }
  },
  mounted: function () {
    console.log(process.env.NODE_ENV);
    if (process.env.NODE_ENV == "production") {
      this.origin = "https://www.kia.cn"
    }
    this.carChoosed = this.carsList[0]
  },
  methods: {
    isShowCarListChange(){
      this.isShowCarList = !this.isShowCarList
    },
    chooseTab(item) {
      this.tabChoosed = item;
      if (item == "内饰") {
        this.chooseInner(this.innerChoosed)
      } else {
        this.chooseColor(this.colorChoosed)
      }
      this.maidian(`新狮铂拓界型页-外观内饰组件-tab选择-${item}`)
    },
    chooseColor(item, type) {
      this.colorChoosed = item
      this.carImg = item.img
      this.tabChoosed = "外观"
      this.bgImg = this.carBgImg
      if (type == 'click') {
        // 手动点击才记录埋点
        this.maidian(`新狮铂拓界型页-外观内饰组件-颜色选择-${item.name}`)
      }
    },
    chooseInner(item,type) {
      this.innerChoosed = item
      this.innerImg = item.img
      this.bgImg = this.origin+this.innerImg
      this.tabChoosed = "内饰"
      if (type == 'click') {
        this.maidian(`新狮铂拓界型页-外观内饰组件-内饰选择-${item.name}`)
      }
    },
    chooseCar(item) {
      if (!this.isShowCarList) {
        return
      }
      this.carChoosed = item
      this.isShowCarList = false
      this.maidian(`新狮铂拓界型页-外观内饰组件-选择车款-新狮铂拓界型页 ${item.name}`)
    },
    maidian(item) {
      console.log('埋点',item);
      try {
        stm_clicki("send", "event", window.location.href+'页面', "点击", item);
      } catch (e) {
        console.error(e);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
$screen_pc: 1920;

@function rempc($px) {
  @return ($px/$screen_pc)*100+vw;
}

.div-container {
  width: 100%;
  height: 100%;
  padding: 4.51vw 11.30vw;
  box-sizing: border-box;
  position: relative;
  background-size: cover;
  .preLoad {
    opacity: 0;
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  .title {
    color: rgba(5, 20, 31, 0.8);
    font-size: rempc(18);
    font-weight: 600;
    line-height: rempc(28);
  }

  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    width: calc(100% - 22.6vw);
    z-index: 9;

    .car {
      position: relative;

      &-name {
        color: rgba(5, 20, 31, 0.8);
        font-size: rempc(48);
        line-height: rempc(72);
        display: flex;
        align-items: center;
        cursor: pointer;

        &-pre {
          font-weight: 500;
          margin-right: rempc(10);
        }

        .jiantou {
          width: rempc(48);
          margin-left: rempc(10);
          transition: transform 0.3s ease;
          transform: rotate(0deg);
          font-weight: 600;

          &.open {
            transform: rotate(180deg);
          }
        }

      }

      &-list {
        position: absolute;
        top: rempc(72);
        width: rempc(310);
        border-radius: rempc(10) rempc(10);
        background: #fff;
        cursor: auto;
        overflow: hidden;
        opacity: 0;
        transform: translateY(-10%);
        transition: all .5s;

        &.open {
          opacity: 1;
          transform: translateY(10%);

          .car-list-item {
            cursor: pointer;
          }
        }

        &-item {
          padding: 0 rempc(20);
          height: rempc(60rem);
          line-height: rempc(60);
          cursor: auto;
          font-size: rempc(32);

          @media screen and (min-width: 768px) {
            font-size: calc(24 / 1920 * 100vw) !important;
            font-weight: 500;
          }


          .pre {
            margin-right: rempc(10);
            font-weight: 500;
          }

          &:hover {
            background: #000;
            color: #fff;
          }
        }
      }
    }

    .tab {
      display: flex;
      align-items: center;
      justify-content: center;
      width: rempc(192);
      border-bottom: rempc(2) solid #d8d8d8;
      font-size: rempc(28);
      line-height: rempc(28);

      &-item {
        flex: 1;
        padding: 0 0 rempc(14);
        cursor: pointer;
        color: #8c8c8c;
        font-family: xihei;
        text-align: center;

        &:first-child {
          text-align: left;
        }

        &:last-child {
          text-align: right;
        }

        &-active {
          color: #000;
          font-family: chuhei;
          position: relative;

          &::before {
            content: "";
            width: 100%;
            height: rempc(3);
            background-color: #000;
            position: absolute;
            bottom: rempc(-2);
            left: 0;
            z-index: 1;
          }
        }
      }
    }
  }

  .bottom {
    width: calc(100% - 22.6vw);
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    // top: 34.5vw;
    top: 81.5vh;
    .color,
    .inner {
      &-name {
        color: #05141F;
        font-family: chuhei;
        font-size: rempc(18);
        line-height: rempc(28);
        margin-bottom: rempc(16);
      }

      &-box {
        display: flex;

        &-item {
          width: rempc(45);
          height: rempc(45);
          // border: 0.5px solid #c3c7c9;
          border-radius: 50%;
          background-size: cover;
          position: relative;
          cursor: pointer;
          margin-right: rempc(15);

          .el-icon-check {
            color: #fff;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: rempc(30);
            font-weight: bold;
          }

          &:last-child {
            margin-right: 0;
          }
        }
      }

      .wrap-box {
        flex-wrap: wrap;
        justify-content: flex-start;
        width: 100%;
      }

      .wrap-item {
        margin-right: rempc(15) !important;
        //margin-left: rempc(15);
        margin-bottom: rempc(10);

        &:last-child {
          margin-right: rempc(15) !important;
        }
      }
    }

    .inner-box {
      justify-content: flex-end;
    }
  }

  .tip {
    color: rgba(5, 20, 31, 0.8);
    font-size: rempc(14);
    line-height: rempc(18);
    position: absolute;
    right: 11.5vw;
    // top: 32.5vw;
    bottom: 19vh;
  }

  .car-img {
    width: rempc(1290);
    height: rempc(600);
    position: absolute;
    z-index: 0;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    user-select: none;
  }

  &-inner {
    color: #fff;

    .title {
      color: #fff;
    }

    .top {
      .car-name {
        color: #fff;

        .car-list-item {
          color: #05141F;

          &:hover {
            color: #fff;
          }
        }
      }

      .tab {
        border-bottom-color: rgba(255, 255, 255, 0.35);

        &-item {
          color: rgba(255, 255, 255, 0.55);

          &-active {
            color: #fff;
          }

          &::before {
            background-color: #fff;
          }
        }
      }
    }

    .bottom {

      .color-name,
      .inner-name {
        color: #fff;
      }

    }

    .tip {
      color: rgba(255, 255, 255, 0.8);
    }
  }

  @media (max-width: 768px) {
    height: 581px;
    padding: 68px 20px;
    background-position: 56%;

    .title {
      font-size: 14px;
      line-height: 100%;
    }

    .top {
      width: calc(100% - 40px);
      margin-top: 8px;

      .car {
        &-name {
          font-size: calc(20 / 375 * 100vw);
          line-height: calc(30 / 375 * 100vw);
          white-space: nowrap;

          &-pre {
            font-weight: 500;
            margin-right: 5px;
          }

          .jiantou {
            width: 24px;
            margin-left: 5px;
          }
        }

        &-list {
          top: 30px;
          width: 180px;
          border-radius: 5px;

          &-item {
            padding: 0 10px;
            height: 40px;
            line-height: 40px;
            font-size: 13px;

            .pre {
              margin-right: 5px;
            }
          }
        }
      }

      .tab {
        width: 94px;
        border-bottom-width: 1px;
        font-size: 14px;
        line-height: 100%;

        &-item {
          padding: 0 0 8px;

          &-active {
            &::before {
              // height: 2px;
              bottom: -1px;
            }
          }
        }
      }
    }

    .bottom {
      width: calc(100% - 40px);
      // top: unset;
      // bottom: 52px;
      top: calc(100vh - 132px);
      .color {
        width: 100%;
      }

      .color,
      .inner {
        &-name {
          font-size: 16px;
          line-height: 24px;
          margin-bottom: 10px;
        }
        &-box {
          &-item {
            width: 33px;
            height: 33px;
            .el-icon-check {
              font-size: 18px;
            }

            &:not(.wrap-item) {
              margin-right: 12px;

              &:last-child {
                margin-right: 0;
              }
            }
          }
        }

        .wrap-box {
          display: flex;
          flex-wrap: wrap;
          // justify-content: center;
          width: 100%;
          gap: 9px 14px;
        }

        .wrap-item {
          flex: 0 0 33px;
          margin: 0 !important;
        }
      }
      .inner-box {
        justify-content: flex-start;
      }
    }
    .tip {
      width: 212px;
      // height: 44px;
      flex-shrink: 0;
      text-align: right;
      font-size: 10px;
      line-height: 14px;
      right: 20px;
      top: unset;
      bottom: 130px;
      // bottom: calc(160 / 375 * 100vw);
    }
    .car-img {
      width: 100%;
      height: auto;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -60%);
      user-select: none;
    }
  }
}</style>
